import { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useScreenshot, createFileName } from '../../../../hooks/useScreenShot';
import { useHistmap } from '../../../../hooks/useHistmap';
import { Button } from '@material-ui/core';
import { BodyBold } from '../../primitive/TypographyUI';
import {
  List,
  ScreenshotContainer,
  FitImage,
  CoverContainer,
  ErrorCover,
  InvalidCover,
  Skeleton,
} from './SharedStyled';

type Props = {
  org_id: string;
  project_id: string;
  round_id: string;
  variation_id: string;
  segment: any;
  src: string;
  hide?: boolean;
  dataLimit?: number;
};

const Histmap: FC<Props> = ({ org_id, project_id, round_id, variation_id, segment, src, hide = false, dataLimit }) => {
  const { containerRef, error, loading, invalidData } = useHistmap(
    org_id,
    project_id,
    round_id,
    variation_id,
    segment,
    dataLimit,
  );

  const [image, takeScreenShot] = useScreenshot({ type: 'image/jpeg', quality: 1.0 });
  const download = (image: string | void, { extension = 'jpg' } = {}) => {
    if (!image) return;
    const a = document.createElement('a');
    a.href = image;
    a.download = createFileName(extension, `histmap_variation:${variation_id}_${segment}`);
    a.click();
  };
  const downloadScreenshot = (ref: any) => {
    takeScreenShot(ref.current, {
      allowTaint: false,
      useCORS: true,
    }).then(download);
  };
  const Screenshot = useMemo(
    () => (
      <ScreenshotContainer className={hide ? 'hidden' : undefined} id={`histmap_${variation_id}`} ref={containerRef}>
        <FitImage src={src} alt={`Histmap-screenshot-${variation_id}`} />
        <CoverContainer>
          {loading && <Skeleton />}
          {error && <ErrorCover> Error... :( </ErrorCover>}
          {invalidData && <InvalidCover>{invalidData}</InvalidCover>}
        </CoverContainer>
      </ScreenshotContainer>
    ),
    [hide, variation_id, src, containerRef, error, loading, invalidData],
  );

  return (
    <List>
      <style>{hiddenStyle}</style>
      <BodyBold>
        <Link to={`../experiments/${project_id}/variations/${variation_id}?tab=overview&org=${org_id}`}>
          {variation_id}
        </Link>
      </BodyBold>
      {Screenshot}
      <Button size="small" color="primary" variant="contained" onClick={() => downloadScreenshot(containerRef)}>
        Download screenshot
      </Button>
      {image && <div>screenshop taken</div>}
    </List>
  );
};

const hiddenStyle = `
.hidden svg {display: none;}
`;

export default Histmap;
